























import { defineComponent, ref } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
const name = 'ttam-location-bulk-upload-file';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  setup(props, { emit }) {
    const formFileList = ref([]);
    const uploadRef = ref();

    async function analysisExcel(file) {
      const { read, utils } = await import(/* webpackChunkName: "xlsx" */ 'xlsx');
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          let datajson = read(data, {
            type: 'binary',
          });
          const result = [];
          datajson.SheetNames.forEach(sheetName => {
            result.push({
              sheetName,
              sheet: utils.sheet_to_json(datajson.Sheets[sheetName], { range: -1 }),
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file);
      });
    }

    async function onChange(file, fileList, rawFile) {
      emit('on-change');
      const resData = await analysisExcel(rawFile);
      const { sheet } = resData[0];
      const list = sheet.map(item => Object.values(item)[0]?.toString());
      emit('analysis-complete', list);
      uploadRef.value.clearFiles();
    }
    return {
      name,
      formFileList,
      uploadRef,
      onChange,
    };
  },
});
